<script>
import AkPictureAccommodation from '@components/v2/general/AkPictureAccommodation.vue';
import reviewMixin from '@mixins/reviewMixin';
import UtilsMixin from '@mixins/utilsMixin';
import reservationSiteConst from '@mixins/const/reservationSiteConst';
import AkShimmer from '@components/v2/general/AkShimmer.vue';
import permissionsMixinComputed from '@mixins/permissionsMixinComputed';

export default {
  name: 'reviewListItem',
  components: {AkPictureAccommodation, AkShimmer},
  mixins: [reviewMixin, UtilsMixin, reservationSiteConst, permissionsMixinComputed],
  props: {
    review: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dateRead: this.review?.dateRead,
    };
  },
  computed: {
    isLoading() {
      return !this.review;
    },
    read() {
      return this.dateRead || Number(this.$route.params.reviewId) === this.review?.id;
    },
  },
  watch: {
    read(oldVal, newVal) {
      if (!oldVal && newVal) {
        this.dateRead = new Date();
      }
    },
  },
};
</script>

<template>
  <div class="p-6 pl-4 flex gap-4 cursor-pointer hover:bg-secondary-50 border-l-[5px] border-transparent">
    <div class="w-[74px] h-[56px] relative shrink-0">
      <AkShimmer :loading="isLoading" width="74px" height="56px">
        <AkPictureAccommodation
          :id="review.accommodationId"
          :md5="review.accommodationMd5"
          :disabledLink="true"
          cover
          height="56"
          small
          radius="rounded-lg"
          :height="134" />
      </AkShimmer>
      <i
        v-if="!isLoading"
        class="logo-site w-[32px] h-[32px] absolute -top-2 -left-2"
        :class="iconReservation(review.reservationSite)"
        v-tooltip.bottom="displayReservationSite(review.reservationSite)" />
    </div>
    <div class="flex flex-col gap-4 grow min-w-0">
      <div class="flex gap-2 items-center justify-between">
        <AkShimmer :loading="isLoading" width="140px" height="20px">
          <span class="text-grey-900 font-bold text-md truncate leading-[18px]">
            {{ review.name }}
          </span>
        </AkShimmer>
        <AkShimmer :loading="isLoading" width="80px" height="16px">
          <span class="text-grey-500 font-medium leading-[18px]">
            {{ formatDateIfNeeded(review.submittedAt) }}
          </span>
        </AkShimmer>
      </div>
      <div class="flex gap-6">
        <div class="flex flex-col gap-1.5 grow min-w-0">
          <AkShimmer :loading="isLoading" width="100%" height="16px">
            <div class="flex gap-1.5 items-center">
              <div v-if="!read" class="h-1.5 min-w-1.5 rounded-full bg-red-600"></div>
              <span class="text-grey-900 truncate leading-[18px]" :class="{'font-bold': !read}">
                {{ review.comment }}
              </span>
            </div>
          </AkShimmer>
          <AkShimmer :loading="isLoading" width="160px" height="16px">
            <div class="flex gap-1 items-center">
              <span
                v-if="!review.dateReplied && isGasGav"
                class="bg-orange-100 px-2.5 py-0.5 flex items-center gap-1.5 rounded-full shrink-0">
                <span class="text-orange-400 text-[10px] leading-[18px] font-medium">Répondre à l'avis</span>
              </span>
              <span class="text-grey-500 font-medium truncate">
                {{ review.accommodationName }}
              </span>
            </div>
          </AkShimmer>
        </div>
        <AkShimmer :loading="isLoading" width="50px" height="24px">
          <div class="flex gap-0.5 h-fit items-center">
            <span
              class="text-xl font-semibold"
              :class="this.colorRatingWithRating(review.reservationSite, review.ratingDisplay)">
              {{ formatNumber(review.ratingDisplay) }}
            </span>
            <span class="text-xl text-grey-500">/{{ scaleRating(review.reservationSite) }}</span>
          </div>
        </AkShimmer>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
